module.exports = __webpack_public_path__ + "static/media/bgRegisterPage.86914b82.jpeg";